var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bulk-provider-select" },
    [
      _c("requests-edit-table", {
        attrs: {
          requests: _vm.allRequests,
          options: _vm.options,
          "group-by": _vm.isListMode ? "provider" : "placeholder",
          "show-status-filter": true,
          "show-label": false,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bulk-recipients-wrapper" },
        [
          _c("edit-table", {
            staticClass: "bulk-recipients is-mobile-scrollable",
            attrs: {
              rows: _vm.recipientRows,
              columns: _vm.recipientColumns,
              load: false,
              "load-options": false,
              "delete-row": false,
              footer: false,
              "hide-filter-row": true,
              "is-zebra": false,
              name: { singular: "Empfänger", plural: "Empfänger" },
            },
            scopedSlots: _vm._u([
              {
                key: "provider",
                fn: function ({ row }) {
                  return [
                    _c(
                      "b",
                      {
                        staticClass: "is-truncated",
                        attrs: { title: row.provider.name },
                      },
                      [_vm._v(_vm._s(row.provider.name))]
                    ),
                    row.isAgency ? [_vm._v(" (Agentur)")] : _vm._e(),
                  ]
                },
              },
              {
                key: "requestsInfo",
                fn: function ({ row }) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "is-truncated",
                        attrs: { title: _vm.groupRequestInfo(row) },
                      },
                      [_vm._v(_vm._s(_vm.groupRequestInfo(row)))]
                    ),
                  ]
                },
              },
              {
                key: "contact",
                fn: function ({ row }) {
                  return [
                    _c("multiselect", {
                      attrs: {
                        value: _vm.bulkGroupContact(row),
                        options: _vm.contactOptions(row),
                        "custom-label": _vm.contactLabel,
                        "allow-empty": false,
                        "track-by": "email",
                        placeholder: _vm.bulkGroupContact(row)
                          ? "Kontakt wählen"
                          : "Kein Kontakt mit Email!",
                      },
                      on: { input: (contact) => _vm.setContact(row, contact) },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }